import { Form } from 'formik';
import P from 'prop-types';
import React, { Children, isValidElement, cloneElement, useState } from 'react';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { showContactUserModalAction } from '../../modules/Modals/Actions';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import getLangData from '../../utils/getLangData';
import Cookies from 'js-cookie';
const ModerationForm = props => {
  const {
    heading,
    isLoading,
    children,
    handleSubmit,
    showContactUserModal,
    noBtn,
    isDisabled = true,
  } = props;
  const [visible, setVisable] = useState(false);
  const history = useHistory();
  const dir = Cookies('lang')
  const goBack = () => {
    history.goBack();
  };
  return (
    <div className='edit row block--container my-5'>
      <div className='col-12'>
        {/* <div className='kt-portlet__head'>
        <div className='kt-portlet__head-label'>
          <h3 className='kt-portlet__head-title'>{heading}</h3>
        </div>
      </div> */}
        <div className='row actions--nav'>
          <div className='col back--action'>
            <Link onClick={goBack} to=''>
              {/* <em className="icon-arrow-left-warshatna" /> */}
              <i
                className={`fas fa-chevron-${dir == 'ar' ? 'right' : 'left'}`}
                style={{
                  padding: '8px',
                  border: '1px solid #000000',
                  borderRadius: '100%',
                  marginRight: '12px'
                }}
              ></i>
              {getLangData().buttons.back}
            </Link>
            <span>{heading}</span>
          </div>
          <div className='col save--action text-right'>
            {/* <button
            
                  onClick={() => showContactUserModal()}
                type='submit'
                className={`btn btn-primary ${
                  isLoading ? "kt-spinner" : ""
                }`
              }
                // disabled={isLoading || disabled}
                >
            {/* <em className="icon-save-warshatna" /> 
            Mark As Moderated
            </button> */}
            <div></div>

            {/* <button href="#" type="button" className="btn btn-primary">
          
        </button> */}
          </div>
        </div>

        <Form className='row mt-5' onSubmit={handleSubmit}>
          <div className='col-12'>
            <div>
              {/* <div className="col-xl-2"></div> */}
              {/* <div className="col-xl-8"> */}
              {/* <div className="kt-section kt-section--first"> */}
              {Children.map(children, child => {
                if (isValidElement(child)) {
                  return cloneElement(child, { disabled: isDisabled });
                }

                return child;
              })}
            </div>
          </div>
          {/* <div className="col-xl-2"></div> */}
          {/* </div> */}
          {/* </div> */}

          {noBtn ? (
            <></>
          ) : (
            <div className='kt-portlet__foot'>
              <div className='kt-form__actions'>
                <div className='row'>
                  <div className='col-12 ml-lg-auto'>
                    <Tooltip
                      overlayInnerStyle={{
                        backgroundColor: 'white',
                        opacity: '100%'
                      }}
                      // overlayStyle={{left: '136px'}}
                      overlayStyle={{ left: '136px' }}
                      placement='topRight'
                      trigger={['click']}
                      animation='zoom'
                      onVisibleChange={visible => setVisable(visible)}
                      visible={visible}
                      overlay={
                        <div>
                          <p>
                            Are you sure you want to mark this record as
                            moderated?
                          </p>
                          <div className='btns'>
                            <button
                              type='button'
                              onClick={() => setVisable(false)}
                              className='btn btn-md btn-label-primary'
                            >
                              No
                            </button>
                            <button
                              type='submit'
                              onClick={() => {
                                setVisable(false);
                                handleSubmit();
                              }}
                              // className="btn btn-md btn-success ml-1"
                              className='btn btn-primary'
                            >
                              Yes
                            </button>
                          </div>
                        </div>
                      }
                      destroyTooltipOnHide={true}
                      overlayClassName={'tooltip-overlay'}
                    >
                      <div className="d-flex justify-content-between w-100">
                        <button
                          type='button'
                          className={`btn btn-primary ${isLoading ? 'kt-spinner' : ''
                            }`}
                          disabled={isLoading}
                        >

                          {getLangData().fields.mark_as_moderated}
                        </button>

                      </div>
                    </Tooltip>

                    {/* <button
                      type='button'
                      className={`btn ml-2 btn-label-primary kt-spinner--right kt-spinner--lg kt-spinner--light ${
                        isLoading ? 'kt-spinner' : ''
                      }`}
                      disabled={isLoading}
                      onClick={() => showContactUserModal()}
                    >
                      {getLangData().fields.contact_person}
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </Form>
      </div>
    </div>
  );
};

ModerationForm.propTypes = {
  heading: P.any.isRequired,
  isLoading: P.bool,
  disabled: P.bool,
  children: P.oneOfType([P.arrayOf(P.node), P.node])
};

ModerationForm.defaultProps = {
  isLoading: false,
  disabled: false
};

export default connect(null, {
  showContactUserModal: showContactUserModalAction
})(ModerationForm);
